import React, { useState } from "react";

// components
import Navbar from "./navbar/Navbar";
import Footer from "./footer";
import { useLocation } from "react-router-dom";
import ChatWidget from "../../components/chat/ChatWidget";
import FloatingChat from "../../components/ui/FloatingChat/FloatingChat";

type IGuestTheme = {
  children: React.ReactNode;
};

const GuestTheme: React.FC<IGuestTheme> = ({ children }) => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const location = useLocation();
  const isHidden =
    location.pathname === "/login" || location.pathname === "/register";

  return (
    <div className="grid w-full">
      <Navbar isHidden={isHidden} />
      <main>{children}</main>
      <Footer isHidden={isHidden} />
      {!isHidden && (
        <div className={isChatOpen ? "hidden sm:block" : undefined}>
          <FloatingChat />
        </div>
      )}
      {!isHidden && (
        <ChatWidget
          isOpen={isChatOpen}
          onToggle={() => setIsChatOpen((prev) => !prev)}
          onClose={() => setIsChatOpen(false)}
        />
      )}
    </div>
  );
};

export default GuestTheme;
